<template>
  <div class="rich-text" v-html="content"></div>
</template>
<script>
export default {
  name: 'rich-text',
  props: {
    content: {
      type: String
    }
  },
  components: {},
};
</script>
